module.exports = __webpack_public_path__ + "media/73_Long.e7c63949.mp3";